import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { deepEqual } from '../utils';

class InfoboxFleet extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  render() {
    return (
      <div className="infobox">
        <div className="infobox-inner">
          <div className="infobox-header">
            <div className="infobox-header-content">
              <h3>{this.props.fleet.name}</h3>
              <h4>{this.props.fleet.operationsManager}</h4>
            </div>

            <div className="infobox-header-action">
              <button className="button button-default" onClick={this.props.onButtonClick}>Ver Detalhes</button>
            </div>
          </div>

          <div className="infobox-meta">
            <ul>
              <li>
                <span>Veículos</span>
                <strong>{this.props.fleet.vehiclesCount}</strong>
              </li>

              <li>
                <span>Rodando</span>
                <strong>{this.props.fleet.vehiclesRunning}</strong>
              </li>

              <li>
                <span>Fat. Médio</span>
                <strong>{this.props.fleet.avgFreightAmount}</strong>
              </li>
            </ul>
          </div>

          <div className="infobox-content">
            <div className="infobox-content-avatars">
              <strong>Motoristas:</strong>

              <ul>
                <li>
                  <span style={{ backgroundImage: 'url(/img/tmp/user-1.jpg)' }} />
                </li>

                <li>
                  <span style={{ backgroundImage: 'url(/img/tmp/user-2.jpg)' }} />
                </li>

                <li>
                  <span style={{ backgroundImage: 'url(/img/tmp/user-3.jpg)' }} />
                </li>

                <li>
                  <span style={{ backgroundImage: 'url(/img/tmp/user-4.jpg)' }} />
                </li>

                <li>
                  <span style={{ backgroundImage: 'url(/img/tmp/user-5.jpg)' }} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InfoboxFleet.propTypes = {
  fleet: PropTypes.object,
  onButtonClick: PropTypes.func.isRequired,
};

InfoboxFleet.defaultProps = {
  fleet: {},
};

export default InfoboxFleet;



// WEBPACK FOOTER //
// ./src/Fleet/InfoboxFleet.js